module.exports = __webpack_public_path__ + "images/179e5ef41fe641f27fc7b13a474400fa610dea04dbefb371fe65cc46980c552c.svg";